exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".proxy-warning-wrp{padding:15px;color:#000;position:fixed;bottom:0;background-color:orange;width:100%;text-align:center;z-index:10000}.proxy-warning-dismiss{cursor:pointer;text-decoration:underline;margin-left:15px;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28b41016","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/partials/AcceptProxyWarning.vue
// module id = 562
// module chunks = 187